import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import Renaissance from "@/pages/home/components/Renaissance";
import ProjectNav from "@/components/feature/ProjectNav";

export default function RenaissancePage() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Renaissance />
        <ProjectNav
          prev={{ label: "Home", to: "/" }}
          next={{ label: "Many Mona", to: "/many-mona" }}
        />
      </main>
      <Footer />
    </div>
  );
}